// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  tokenEndPoint: 'https://aquilonefarigliano.auth.eu-central-1.amazoncognito.com/oauth2/token',
  clientId: 'q9kdj06pld811ldslgpet09j8',
  clientCredential: '10pcbvenaqr69ogmr6tmmnd1tn7sjsht1oda3qjd8m8qtjrmcqtf',
  version: require("../../package.json").version,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
